import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		layout: {
			minHeight: "100vh",
			background: "#FAFAFA",
			display: "flex",
			flexDirection: "column" as const,
			alignItems: "center",
			justifyContent: "center",
			padding: "2em",
			gap: 24,
		},
		container: {
			background: "white",
			width: 480,
			borderRadius: 8,
			border: "1px solid #DDE7E8",
			display: "flex",
			flexDirection: "column" as const,
			alignItems: "center",
			paddingLeft: 40,
			paddingRight: 40,
			paddingTop: 40,
			paddingBottom: 40,
		},
		logo: {
			maxHeight: 48,
			maxWidth: "100%",
			objectFit: "contain" as const,
			objectPosition: "center",
		},
		header: {
			marginBottom: 8,
			fontWeight: "bold" as const,
		},
		subtitle: {
			marginBottom: 24,
			color: "#666",
			textAlign: "center" as const,
		},
	} satisfies Record<string, CSSObject>);
};
